import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ErrorComponent, RestrictedUserComponent, PageNotFoundComponent, SupportComponent } from 'lib/ng2-sapmp/src/pages';
import { NavigationToBlockGuard } from './pages/initial-signup/navigationBlock.guard';
import { ErrorPageComponent } from './pages/error-pages';
import { ContactComponent } from './pages/contact';
import { ConfirmOrderComponent } from './pages/confirm-order';
import { AuthenticationComponent } from './pages/authentication';
import { AbmFaciliateEnrollmentComponent, FaqComponent } from './pages'

import {
  TermsConditionsComponent, SystemErrorComponent, SystemMaintenanceComponent, GridComponent
} from './pages';
import { CMSResolver } from 'lib/ng2-sapmp/src/providers/cms.resolver';

import { UserProfileGuard } from 'lib/ng2-sapmp/src/guards/user-profile.guard';
import { MultiStubIdProfileGuard } from 'lib/ng2-sapmp/src/guards/multistubid-profile.guard';
import { AdminGuard } from 'lib/ng2-sapmp/src/guards/admin.guard';
import { BlockNavigationGuard } from './pages/product-selection/blockNavigation.guard';
import { FaqAccessGuard } from './pages/faq/faq-access.guard';
import { MultiStubidPageComponent} from './pages/multi-stubid-page/multi-stubid-page.component';
import { DeviceSubmissionTrackingComponent } from './pages/care/deviceSubmissionTracking/device-submission-tracking.component';

export const appRoutes: Routes = [
  {
    path: 'srhome',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [MultiStubIdProfileGuard]
  },
  { path: 'browse', loadChildren: () => import('./modules/browse/browse.module').then(m => m.BrowseModule) },
  {
    path: 'productConfigurator/:id',
    loadChildren: () => import('./modules/product-configurator/product-configurator.module').then(m => m.ProductConfiguratorModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'cart', loadChildren: () => import('./modules/cart/cart.module').then(m => m.CartModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'checkout', loadChildren: () => import('./modules/checkout/checkout.module').then(m => m.CheckoutModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'efotaenrollment',
    loadChildren: () => import('./modules/signup-efota/signup-efota.module').then(m => m.SignUpEfotaModule),
  },
  {
    path: 'efotareports',
    loadChildren: () => import('./modules/report-detail/report-detail.module').then(m => m.ReportDetailModule),
  },
  {
    path: 'fiveg',
    loadChildren: () => import('./modules/5g/5g-customer.module').then(m => m.FiveGCustomerModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'manage',
    loadChildren: () => import('./modules/manage-licenses/manage-licenses.module').then(m => m.ManageLicensesModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'manageProduct',
    loadChildren: () => import('./modules/manage-product/manage-product.module').then(m => m.ManageProductModule),
  },
  {
    path: 'manageUsers',
    loadChildren: () => import('./modules/manage-users/manage-users.module').then(m => m.ManageUsersModule),
  },
  {
    path: 'licensesBuyProduct',
    loadChildren: () => import('./modules/licenses-buy-product/licenses-buy-product.module').then(m => m.LicensesBuyProductModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'changeProduct',
    loadChildren: () => import('./modules/change-product/change-product.module').then(m => m.ChangeProductModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'user',
    loadChildren: () => import('./modules/user/user.module').then(m => m.UserModule),
  },
  {
    path: 'bulkUsers',
    loadChildren: () => import('./modules/bulk-users/bulk-users.module').then(m => m.BulkUsersModule),
    canActivate: [UserProfileGuard],
  },
  // Commenting out as a part of US-1364
  // {
  //    path: 'learn', loadChildren: () => import('./modules/learn/learn.module').then(m => m.LearnModule),
  //   canActivate: [MultiStubIdProfileGuard],
  //   resolve: { pageData: CMSResolver }
  // },
  {
    path: 'learn',
    children: [
      { path: '', component: PageNotFoundComponent, pathMatch: 'full' },
      { path: '**', component: PageNotFoundComponent }
    ]
  },
  {
    path: 'manageInventory',
    loadChildren: () => import('./modules/manage-inventory/manage-inventory.module').then(m => m.ManageInventoryModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'appleCertificate',
    loadChildren: () => import('./modules/apple-certificate/apple-certificate.module').then(m => m.AppleCertificateModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'cancelParticipation',
    loadChildren: () => import('./modules/cancel-participation/cancel-participation.module').then(m => m.CancelParticipationModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'signup',
    loadChildren: () => import('./modules/signup/signup.module').then(m => m.SignupModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'welcome', loadChildren: () => import('./modules/welcome/welcome.module').then(m => m.WelcomeModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'productselection',
    loadChildren: () => import('./modules/product-selection/product-selection.module').then(m => m.ProductSelectionModule),
    canActivate: [UserProfileGuard, BlockNavigationGuard]
  },
  {
    path: 'signupsetup',
    loadChildren: () => import('./modules/signup-setup/signup-setup.module').then(m => m.SignupSetupModule),
    canActivate: []
  },
  {
    path: 'enrollmentTool',
    loadChildren: () => import('./modules/enrollment-tool/enrollment-tool.module').then(m => m.EnrollmemtToolModule),
    canActivate: [UserProfileGuard, NavigationToBlockGuard]
  },
  {
    path: 'sendMessage',
    loadChildren: () => import('./modules/sms/sms.module').then(m => m.SmsModule),
    canActivate: [UserProfileGuard]
  },
  {
    path: 'reports/transaction',
    loadChildren: () => import('./modules/report/report.module').then(m => m.ReportModule)
  },
  {
    path: 'care',
    loadChildren: () => import('./modules/care/care.module').then(m => m.CareModule),
    canActivate: [AdminGuard]
  },
  {
     path: 'device-submission-tracking', component: DeviceSubmissionTrackingComponent ,
  },
  // {
  //   path: 'faq',
  //   loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule),
  //   canActivate: []
  // },
  {
    path: 'groupingDevices',
    loadChildren: () => import('./modules/grouping-devices/grouping-devices.module').then(m => m.GroupingDevicesModule),
    canActivate: []
  },
  {
    path: 'manageGroups',
    loadChildren: () => import('./modules/manage-groups/manage-groups.module').then(m => m.ManageGroupsModule),
    canActivate: []
  },
  { path: 'systemError', component: SystemErrorComponent },
  { path: 'systemMaintenance', component: SystemMaintenanceComponent },
  { path: 'support', component: SupportComponent },
  {
    path: 'faq',
    loadChildren: () => import('./modules/faq/faq.module').then(m => m.FaqModule),
    canActivate: [FaqAccessGuard]
  },
  // { path: 'faq', component: FaqComponent },
  { path: 'terms', component: TermsConditionsComponent },
  { path: 'error/:errorCode', component: ErrorPageComponent },
  {
    path: 'contact', component: ContactComponent,

    resolve: { pageData: CMSResolver }
  },

  { path: 'abmfacilitatedenrollment', component: AbmFaciliateEnrollmentComponent, resolve: { pageData: CMSResolver } },
  { path: 'authentication', component: AuthenticationComponent },
  { path: 'confirmorder', component: ConfirmOrderComponent },
  { path: 'errorPage/:errorCode', component: ErrorPageComponent },
  { path: 'restrictedUser', component: RestrictedUserComponent },
  { path: 'serverError/:errCode', component: ErrorComponent },
  { path: 'grid', component: GridComponent },
  {
    path: 'efotaoffer',
    redirectTo: 'browse/details/efota',
    pathMatch: 'full'
  },
  { path: 'businesconsole', redirectTo: 'home', pathMatch: 'full' },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'selectstubid', component: MultiStubidPageComponent },
  { path: '', redirectTo: 'businessconsole/home', pathMatch: 'full' },
  { path: '**', component: PageNotFoundComponent },
];

export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders<any> = RouterModule.forRoot(appRoutes);
